<template>
  <div class="page border-box clearfix" v-wechat-title="$route.meta.title='邀请码须知'">
    <div class="q_box">
      <p class="q"><span>Q：</span> 如何获取邀请码？</p>
      <p class="a"><span>A：</span>邀请码由您的上级管理部门发放，请务必联系您的推广团队管理员获取，并正确填写。</p>
    </div>
    <div class="q_box">
      <p class="q"><span>Q：</span>没有上级推广管理团队如何获取邀请码？</p>
      <p class="a"><span>A：</span>如无上级推广管理团队可不填写</p>
    </div>
  </div>

</template>

<script>
  import axios from 'axios'
  import Qs from 'qs'
  import { mapState, mapMutations } from 'vuex'
  import {wxShareme} from '@/utils/wechat'
  import {getServer} from '@/utils/share'
  import {setStore, getStore, removeStore} from '@/config/mUtils'
  import D from '@/wc-messagebox'
  import Vue from 'vue'
  Vue.use(D)

  export default {
    data(){
      return{
        TimeStamp: new Date().getTime(),  //获取当前时间
        userInfo: {},
      }
    },
    computed: {

    },
    created() {

    },
    beforeDestroy(){
      window.removeEventListener("scroll", function () {});
    },
    methods: {

    },
    components: {

    },

  }

</script>

<style scoped>
  .page{ position: relative; width: 100%;min-height: 100vh;padding:.25rem .24rem 0;background: #fff;}
  .page p{font-size: .26rem;color: #333;}
  .q_box .q{margin-top: .32rem;}
  .q_box:first-child .q{margin-top: 0;}
  .q_box .q span{float:left;color:#c69000;}
  .q_box .a{margin-top: .1rem;}
  .q_box .a span{float:left;color:#3134cb;}
</style>



// WEBPACK FOOTER //
// src/page/extend-article/extend-article.vue